import { PaginationResponse, api } from './api';

export interface OptionEntity {
  id: number;
  field: string;
  labels: [number, Record<string, string>][]; // [1, { en: 'en_a', cn: 'cn_a' }][]
  createdAt?: string;
  updatedAt?: string;
}

export interface FindManyOptionResponse extends PaginationResponse {
  data: OptionEntity[];
}

export const optionApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getProfileFields: builder.query<string[], void>({
      query: () => ({
        url: '/options/profile-fields',
        method: 'GET',
      }),
    }),
    findManyOptions: builder.query<FindManyOptionResponse, void>({
      query: () => ({
        url: '/options',
        method: 'GET',
      }),
    }),
    createOption: builder.mutation<OptionEntity, Partial<OptionEntity>>({
      query: (body) => ({
        url: '/options',
        method: 'POST',
        body,
      }),
    }),
    updateOption: builder.mutation<OptionEntity, Partial<OptionEntity>>({
      query: ({ id, ...body }) => ({
        url: `/options/${id}`,
        method: 'PATCH',
        body,
      }),
    }),
    deleteOption: builder.mutation<void, number>({
      query: (id) => ({
        url: `/options/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetProfileFieldsQuery,
  useFindManyOptionsQuery,
  useCreateOptionMutation,
  useUpdateOptionMutation,
  useDeleteOptionMutation,
} = optionApi;
